"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
/**
 * Primary button component.
 * Native HTML button element is used.
 */
exports.PrimaryButton = styled_components_1.default.button `
  padding: 12px 16px;
  margin: 0;
  width: 224px;

  background: ${({ theme }) => theme.userOnboarding.primaryButton.enabled.background};
  border-radius: 4px;
  border: none;

  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  text-transform: uppercase;
  text-align: center;

  color: ${({ theme }) => theme.userOnboarding.primaryButton.enabled.text};

  cursor: pointer;

  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      background: ${({ theme }) => theme.userOnboarding.primaryButton.disabled.background};

      color: ${({ theme }) => theme.userOnboarding.primaryButton.disabled.text};

      cursor: default;
    `}
`;
